<template>
    <div class="float-left">
        <b-button
            variant="success"
            v-if="
                $temAcessoView('ATADIREX-12') &&
                modoCadastro &&
                nuSituacaoAta == 1
            "
            @click="abrirModal()"
            >Adicionar
        </b-button>

        <i
            class="fa fa-pencil fa-lg icon-button"
            title="Alterar"
            v-if="
                $temAcessoView('ATADIREX-13') &&
                !modoCadastro &&
                !processoCancelado
            "
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalCadProcessosAtaDirex"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Processo Ata Direx -
                <b-badge variant="warning">{{ modoTela }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <!-- Dados da Ata -->
            <!-- <b-card> -->
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="cdTipoAta">Tipo Ata</label>
                        <b-form-select
                            id="cdTipoAta"
                            type="text"
                            :options="tipoAta"
                            value-field="key"
                            text-field="label"
                            v-model="ataDirex.cdTipoAta"
                            :disabled="true"
                        >
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuAtaDirex">Ata Direx</label>
                        <b-form-input
                            id="nuAtaDirex"
                            type="text"
                            placeholder="99/9999"
                            v-model="ataDirex.nuAtaDirex"
                            v-mask="['##/####']"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtReuniao">Data Reunião</label>
                        <b-input-group>
                            <date-picker
                                id="dtReuniao"
                                v-model="ataDirex.dtReuniao"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                :disabled="true"
                            ></date-picker>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <hr/> -->
            <!-- </b-card> -->
            <!-- Fim Dados da Ata -->

            <!-- Dados Processo -->
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuProcesso">Processo</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="nuProcesso"
                                v-mask="'############'"
                                @keyup="obterProcessoPorNumero()"
                                placeholder="Digite o número do processo"
                                v-model="processoAtaDirexDto.nuProcesso"
                                :disabled="!modoCadastro"
                                @input.native="
                                    $v.processoAtaDirexDto.nuProcesso.$touch()
                                "
                                :state="
                                    $v.processoAtaDirexDto.nuProcesso.$error
                                        ? false
                                        : null
                                "
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O Processo é
                                Obrigatório</b-form-invalid-feedback
                            >
                            <!-- <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="obterProcessoPorNumero()"
                                    title="Clique para pesquisar o processo"
                                    :disabled="!modoCadastro"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append> -->
                            <b-form-invalid-feedback
                                >O Processo é
                                Obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <!--
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuProcesso">Processo</label>
                        <b-form-input
                            id="nuProcesso"
                            type="text"
                            v-model="processoAtaDirexDto.nuProcesso"
                            :disabled="!modoCadastro"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                -->
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="interessadoGEDOC">Interessado GEDOC</label>
                        <b-form-input
                            id="interessadoGEDOC"
                            type="text"
                            v-model="this.interessadoGEDOC"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="criadoPorGEDOC">Criado por no GEDOC</label>
                        <b-form-input
                            id="criadoPorGEDOC"
                            type="text"
                            v-model="this.criadoPorGEDOC"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="unidadeGEDOC">Unidade GEDOC</label>
                        <b-form-input
                            id="unidadeGEDOC"
                            type="text"
                            v-model="this.unidadeGEDOC"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcObjetoProcesso">Objeto GEDOC</label>
                        <b-input-group>
                            <b-form-textarea
                                id="vcObjetoProcesso"
                                type="text"
                                v-model="processoAtaDirexDto.vcObjetoProcesso"
                                placeholder="Objeto"
                                :rows="4"
                                @input.native="
                                    $v.processoAtaDirexDto.vcObjetoProcesso.$touch()
                                "
                                :state="
                                    $v.processoAtaDirexDto.vcObjetoProcesso
                                        .$error
                                        ? false
                                        : null
                                "
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                >Objeto é Obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="idTipoContrato">Tipo</label>
                        <b-form-select
                            id="idTipoContrato"
                            type="text"
                            :options="tipoContrato"
                            value-field="key"
                            text-field="label"
                            v-model="processoAtaDirexDto.idTipoContrato"
                            @input.native="
                                $v.processoAtaDirexDto.idTipoContrato.$touch()
                            "
                            :state="
                                $v.processoAtaDirexDto.idTipoContrato.$error
                                    ? false
                                    : null
                            "
                        >
                        </b-form-select>
                        <b-form-invalid-feedback
                            >O Tipo do Contrato é
                            Obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="nuFolhaAtaDirex">Folha</label>
                        <b-form-input
                            id="nuFolhaAtaDirex"
                            v-mask="'############'"
                            type="text"
                            v-model="processoAtaDirexDto.nuFolhaAtaDirex"
                            @input.native="
                                $v.processoAtaDirexDto.nuFolhaAtaDirex.$touch()
                            "
                            :state="
                                $v.processoAtaDirexDto.nuFolhaAtaDirex.$error
                                    ? false
                                    : null
                            "
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O Número da Folha é
                            Obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="codSolicitante">Solicitante</label>
                        <b-form-select
                            id="codSolicitante"
                            type="text"
                            :options="solicitantes"
                            value-field="codFuncionario"
                            text-field="nome"
                            v-model="processoAtaDirexDto.codSolicitante"
                            @input.native="
                                $v.processoAtaDirexDto.codSolicitante.$touch()
                            "
                            :state="
                                $v.processoAtaDirexDto.codSolicitante.$error
                                    ? false
                                    : null
                            "
                        >
                        </b-form-select>
                        <b-form-invalid-feedback
                            >O Solicitante é
                            Obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="codUnidade">Unidade</label>
                        <b-form-select
                            id="codUnidade"
                            type="text"
                            :options="unidades"
                            value-field="codUnidade"
                            text-field="nome"
                            v-model="processoAtaDirexDto.codUnidade"
                            @input.native="
                                $v.processoAtaDirexDto.codUnidade.$touch()
                            "
                            :state="
                                $v.processoAtaDirexDto.codUnidade.$error
                                    ? false
                                    : null
                            "
                        >
                        </b-form-select>
                        <b-form-invalid-feedback
                            >A Unidade é Obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuValorGlobalProcesso">Valor Total</label>
                        <b-input-group>
                            <money
                                id="nuValorGlobalProcesso"
                                v-model="valor"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                                :state="$v.valor.$error ? false : null"
                            ></money>
                        </b-input-group>
                        <b-form-invalid-feedback
                            >O Valor Total é
                            Obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- Fim Dados Processo -->

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="salvar()"
                    class="ml-1"
                    :disabled="$v.$invalid"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import AtaDirexServicos from '../AtaDirexServicos'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        ProcessoAtaDirexPai: Object,
        modoCadastro: Boolean,
        processoCancelado: Boolean
    },

    validations: {
        // interessadoGEDOC: { required },
        // criadoPorGEDOC: { required },
        // unidadeGEDOC: { required },

        valor: {
            required,
            minValue: minValue(0.0)
        },

        processoAtaDirexDto: {
            nuProcesso: { required },
            vcObjetoProcesso: { required },
            nuFolhaAtaDirex: { required },
            nuValorGlobalProcesso: { required },
            idTipoContrato: { required },
            codUnidade: { required },
            codSolicitante: { required }
        }
    },

    data() {
        return {
            modoTela: null,
            mostrarModal: false,
            nuSituacaoAta: this.$route.params.nuSituacaoAta,
            erros: [],
            ataDirex: {},
            solicitantes: [],
            unidades: [],
            valor: 0,

            interessadoGEDOC: '',
            criadoPorGEDOC: '',
            unidadeGEDOC: '',

            tipoAta: [
                {
                    key: '1',
                    label: 'Ordinária'
                },
                {
                    key: '2',
                    label: 'Extraordinária'
                }
            ],
            tipoContrato: [
                {
                    key: '1',
                    label: 'Contrato'
                },
                {
                    key: '2',
                    label: 'Convênio'
                }
            ],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            processoAtaDirexDto: {
                idProcessoAta: 0,
                idAtaDirex: this.$route.params.idAtaDirex,
                nuProcesso: null,
                nuFolhaAtaDirex: null,
                vcObjetoProcesso: null,
                vcNomeSolicitanteGdoc: null,
                idTipoContrato: null,
                codUnidade: null,
                codSolicitante: 0,
                nuValorGlobalProcesso: 0,
                dtCadastro: null,
                idSituacaoProcesso: 0,
                usrLoginCadastro: null
            }
        }
    },

    created() {
        if (this.$route.params.mostrarModal == true) {
            this.abrirModal()
        }
    },

    methods: {
        addZeroes(num, len) {
            var numberWithZeroes = String(num)
            var counter = numberWithZeroes.length

            while (counter < len) {
                numberWithZeroes = '0' + numberWithZeroes
                counter++
            }

            return numberWithZeroes
        },

        obterAtaDirex() {
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ObterInformacoesGeraisAta(
                this.$route.params.idAtaDirex
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.ataDirex = response.data
                        this.ataDirex.dtReuniao = this.$moment(
                            this.ataDirex.dtReuniao,
                            'YYYY-MM-DD'
                        ).format('DD/MM/YYYY')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        limpar() {
            this.processoAtaDirexDto.idProcessoAta = 0
            this.processoAtaDirexDto.idAtaDirex = this.$route.params.idAtaDirex
            this.processoAtaDirexDto.nuProcesso = null
            this.processoAtaDirexDto.nuFolhaAtaDirex = null
            this.processoAtaDirexDto.vcObjetoProcesso = null
            this.processoAtaDirexDto.vcNomeSolicitanteGdoc = null
            this.processoAtaDirexDto.idTipoContrato = 0
            this.processoAtaDirexDto.codUnidade = 0
            this.processoAtaDirexDto.codSolicitante = 0
            this.processoAtaDirexDto.nuValorGlobalProcesso = 0
            this.processoAtaDirexDto.dtCadastro = null
            this.processoAtaDirexDto.idSituacaoProcesso = 0
            this.processoAtaDirexDto.usrLoginCadastro = null

            this.interessadoGEDOC = null
            this.criadoPorGEDOC = null
            this.unidadeGEDOC = null

            this.valor = 0

            this.erros = []
        },

        Carregar() {
            this.processoAtaDirexDto.idProcessoAta =
                this.ProcessoAtaDirexPai.idProcessoAta
            this.processoAtaDirexDto.idAtaDirex =
                this.ProcessoAtaDirexPai.idAtaDirex
            this.processoAtaDirexDto.nuProcesso =
                this.ProcessoAtaDirexPai.nuProcesso
            this.processoAtaDirexDto.nuFolhaAtaDirex =
                this.ProcessoAtaDirexPai.nuFolhaAtaDirex
            this.processoAtaDirexDto.vcObjetoProcesso =
                this.ProcessoAtaDirexPai.vcObjetoProcesso
            this.processoAtaDirexDto.vcNomeSolicitanteGdoc =
                this.ProcessoAtaDirexPai.vcNomeSolicitanteGdoc
            this.processoAtaDirexDto.idTipoContrato =
                this.ProcessoAtaDirexPai.idTipoContrato
            this.processoAtaDirexDto.codUnidade = this.addZeroes(
                this.ProcessoAtaDirexPai.codUnidade,
                3
            ) //this.ProcessoAtaDirexPai.codUnidade
            this.processoAtaDirexDto.codSolicitante =
                this.ProcessoAtaDirexPai.codSolicitante
            this.processoAtaDirexDto.nuValorGlobalProcesso =
                this.ProcessoAtaDirexPai.nuValorGlobalProcesso
            this.processoAtaDirexDto.dtCadastro = this.$moment(
                this.ProcessoAtaDirexPai.dtCadastro
            ).format('DD/MM/YYYY')
            this.processoAtaDirexDto.idSituacaoProcesso =
                this.ProcessoAtaDirexPai.idSituacaoProcesso
            this.processoAtaDirexDto.usrLoginCadastro =
                this.ProcessoAtaDirexPai.usrLoginCadastro

            this.valor = this.ProcessoAtaDirexPai.nuValorGlobalProcesso
        },

        abrirModal() {
            this.limpar()
            this.obterAtaDirex()
            this.listarUnidades()
            this.listarSolicitantes()
            this.mostrarModal = true

            this.modoTela = 'NOVO'
            if (!this.modoCadastro) {
                this.modoTela = 'EDITAR'
                this.Carregar()
                this.obterProcessoPorNumero()
            }
        },

        fecharModal() {
            this.erros = []
            this.mostrarModal = false
            if (this.$route.params.mostrarModal == true) {
                this.$router.push({
                    name: 'AtaDirexDetalhes',
                    params: {
                        idAtaDirex: this.processoAtaDirexDto.idAtaDirex,
                        tabindex: 1,
                        mostrarModal: false,
                        nuSituacaoAta: this.nuSituacaoAta
                    }
                })
            }
        },

        salvar() {
            //
            this.processoAtaDirexDto.nuValorGlobalProcesso = this.valor
            //
            if (this.modoCadastro) {
                this.$store.dispatch('addRequest')
                AtaDirexServicos.SalvarProcessoAtaDirex(
                    this.processoAtaDirexDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$emit('listarProcessos')
                            this.fecharModal()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.processoAtaDirexDto.dtCadastro = this.$moment(
                    this.processoAtaDirexDto.dtCadastro,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
                this.$store.dispatch('addRequest')
                AtaDirexServicos.AtualizarProcessoAtaDirex(
                    this.processoAtaDirexDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$emit('listarProcessos')
                            this.fecharModal()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        listarSolicitantes() {
            if (this.modoCadastro) {
                this.$store.dispatch('addRequest')
                AtaDirexServicos.ListarFuncionariosRM(null).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.solicitantes = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.$store.dispatch('addRequest')
                AtaDirexServicos.ListarFuncionariosRM(
                    this.ProcessoAtaDirexPai.codSolicitante
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.solicitantes = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        listarUnidades() {
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ListarUnidadesRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProcessoPorNumero() {
            this.erros = []
            if (
                this.processoAtaDirexDto.nuProcesso != null &&
                this.processoAtaDirexDto.nuProcesso.length == 12
            ) {
                this.$store.dispatch('addRequest')
                AtaDirexServicos.obterProcessoGedocPorNumero(
                    this.processoAtaDirexDto.nuProcesso,
                    this.modoCadastro
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.interessadoGEDOC = response.data.nome
                            this.criadoPorGEDOC = response.data.cadastradoPor
                            this.unidadeGEDOC = response.data.unidade
                            if (this.modoCadastro) {
                                this.processoAtaDirexDto.vcObjetoProcesso =
                                    response.data.assunto
                                this.processoAtaDirexDto.vcNomeSolicitanteGdoc =
                                    response.data.nome
                            }
                        } else {
                            if (this.erros.length > 0) {
                                this.erros = []
                            }
                            this.erros.push(
                                'Processo não encontrado, ou já inserido anteriormente nesta ou em outra Ata Direx.'
                            )
                            this.interessadoGEDOC = null
                            this.criadoPorGEDOC = null
                            this.unidadeGEDOC = null
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.interessadoGEDOC = null
                this.criadoPorGEDOC = null
                this.unidadeGEDOC = null
                if (this.modoCadastro) {
                    this.processoAtaDirexDto.vcObjetoProcesso = null
                }
                if (this.erros.length > 0) {
                    this.erros = []
                }
            }
        }
    }
}
</script>
